<template>
  <div>
    <div v-show="divShow">
      <a-spin :spinning="spinning.details">
        <div class="drivasst-details">
          <span class="drivasst-name">{{drivasstdetails.drivasstname}}</span>
          <a-button
            icon="close"
            style="float:right;margin-left:20px"
            @click="close()"
          >关闭</a-button>
          <a-button
          type="primary"
          style="float:right;display:none">下载详情<a-icon type="file-word" /></a-button>
          <a-row style="margin:15px 0 15px 20px">
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">城市代码 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.city}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">联系人邮箱 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.contactsemail}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">联系人手机 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.contactsmobile}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">联系人名称 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.contactsname}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">联系人电话 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.contactsphone}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">区县代码 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.county}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">创建时间 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.credatetime}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">驾协地址 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.drivasstadress}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">驾协ID : </span>
                <span class="drivasst-details-value">{{drivasstdetails.drivasstid}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">驾协名称 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.drivasstname}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">驾协简称 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.drivasstshtname}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">财务人联系手机 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.finacontactsmobile}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">财务人联系邮箱 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.fincontactsemail}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">财务人名称 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.fincontactsname}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">财务人联系电话 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.fincontactsphone}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">创建人ID : </span>
                <span class="drivasst-details-value">{{drivasstdetails.inputopr}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">修改时间 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.moddatetime}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">修改人 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.modopr}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">省代码 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.provice}}</span>
              </div>
            </a-col>
            <a-col :span='8'>
              <div class="drivasst-details-keyvalue">
                <span class="drivasst-details-key">下属驾校数量 : </span>
                <span class="drivasst-details-value">{{drivasstdetails.subordinatenum}}</span>
              </div>
            </a-col>
          </a-row>
        </div>
      </a-spin>
      <a-divider />
      <a-spin :spinning="spinning.accum">
        <div class="accum-data">
          <span class="span-title">累计数据</span>
          <a-row
            type="flex"
            justify="space-around"
            style="margin-bottom:40px"
          >
            <a-col :span='8'>
                <div class="accum-title">交易总额</div>
                <div class="accum-number">{{accumData.tradeamttotal}}<font style="font-size:16px">元</font></div>
            </a-col>
            <a-col :span='8'>
                <div class="accum-title">培训合同数</div>
                <div class="accum-number">{{accumData.contractnum}}</div>
            </a-col>
            <a-col :span='8'>
                <div class="accum-title">预付培训费金额</div>
                <div class="accum-number">{{accumData.superviseamttotal}}<font style="font-size:16px">元</font></div>
            </a-col>
          </a-row>
        </div>
      </a-spin>
      <a-divider />
      <div style="margin-top:20px;">
        <a-row>
          <a-col :span='12'>
            <!-- <a-spin :spinning="spinning.personPie">
              <div>
                <span class="span-title">驾校培训人数占比</span>
                <div :style="pieStyle">
                  <v-chart :options="trainPerPie" />
                </div>
              </div>
            </a-spin> -->
          </a-col>
          <a-col :span='12'>
            <!-- <a-spin :spinning="spinning.incomePie">
              <div>
                <span class="span-title">驾校培训收入占比</span>
                <div :style="pieStyle">
                  <v-chart :options="trainIncomePie" />
                </div>
              </div>
            </a-spin> -->
          </a-col>
        </a-row>

      </div>
      <!-- <a-divider /> -->
      <!-- <a-spin :spinning="spinning.pass">
        <div class="train-pass" style="margin-top:20px">
          <span class="span-title">各科目培训通过率</span>
          <a-row
            style="margin:20px 0"
            type="flex"
            justify="space-around"
            align="middle"
          >
            <a-col :span='5'>
              <div style="display:flex;align-items:center">
                <div style="float:left;padding-right:25px">
                  <div class="train-project">科目1</div>
                  <div class="train-pass-title">培训通过率</div>
                  <div class="train-pass-percent">75%</div>
                </div>
                <div>
                  <a-progress
                    strokeLinecap="square"
                    :percent="75"
                    :width='60'
                    :strokeWidth='16'
                    :showInfo='false'
                    type="circle"
                  />
                </div>
              </div>
            </a-col>
            <a-col :span='5'>
              <div style="display:flex;align-items:center">
                <div style="float:left;padding-right:25px">
                  <div class="train-project">科目2</div>
                  <div class="train-pass-title">培训通过率</div>
                  <div class="train-pass-percent">75%</div>
                </div>
                <div>
                  <a-progress
                    strokeLinecap="square"
                    :percent="75"
                    :width='60'
                    :strokeWidth='16'
                    :showInfo='false'
                    strokeColor='#FAD337'
                    type="circle"
                  />
                </div>
              </div>
            </a-col>
            <a-col :span='5'>
              <div style="display:flex;align-items:center">
                <div style="float:left;padding-right:25px">
                  <div class="train-project">科目3</div>
                  <div class="train-pass-title">培训通过率</div>
                  <div class="train-pass-percent">75%</div>
                </div>
                <div>
                  <a-progress
                    strokeLinecap="square"
                    :percent="75"
                    :width='60'
                    :strokeWidth='16'
                    :showInfo='false'
                    strokeColor='#36CBCB'
                    type="circle"
                  />
                </div>
              </div>
            </a-col>
            <a-col :span='5'>
              <div style="display:flex;align-items:center">
                <div style="float:left;padding-right:25px">
                  <div class="train-project">科目4</div>
                  <div class="train-pass-title">培训通过率</div>
                  <div class="train-pass-percent">75%</div>
                </div>
                <div>
                  <a-progress
                    strokeLinecap="square"
                    :percent="75"
                    :width='60'
                    :strokeWidth='16'
                    :showInfo='false'
                    strokeColor='#4ECB74'
                    type="circle"
                  />
                </div>
              </div>
            </a-col>

          </a-row>
        </div>
      </a-spin> -->
      <a-divider />
      <div style="margin-top:30px">
        <span class="span-title">下属驾校信息</span>
        <j-table
          style="margin-top:20px;"
          :tableColumns="columns"
          :rowKey="record => record.drivschid"
          :tableData="schoolList"
          :loading="loading"
          :tablePagination="pagination"
          :slotWidth="200"
          v-on:onOrderbyChange="(newOrderby)=>{ orderby = newOrderby;getSchoolList(); }"
          v-on:onPaginationChange="(newPagination)=>{ pagination = newPagination;getSchoolList(); }"
        >
          <template v-slot="record">
            <a @click="showDetails(record)">详情</a>
          </template>
        </j-table>
      </div>
    </div>
    <d-school
      v-if="detailShow"
      :parameters="params"
      v-on:onClose="()=>{detailShow = false;divShow = true;}"
    >
    </d-school>
  </div>
</template>
<script>
import JTable from "./JTable";
import DSchool from "./SchoolDetails";

/**
 * 下属驾校列表表头
 */
const columns = [
  {
    title: "驾校简称",
    dataIndex: "drivschshtname",
    key: "drivschshtname",
    fixed: "left",
    align: "center"
  },
  //   {
  //     title: "驾校ID",
  //     dataIndex: "drivschid",
  //     key: "drivschid",
  //     fixed: "left",
  //     align: "center"
  //   },
  {
    title: "驾校名称",
    dataIndex: "drivschname",
    key: "drivschname",
    align: "center",
    fixed: "left"
  },
  //   {
  //     title: "驾协ID",
  //     dataIndex: "drivasstid",
  //     key: "drivasstid",
  //     align: "center"
  //   },
  //   {
  //     title: "创建时间",
  //     dataIndex: "credatetime",
  //     key: "credatetime",
  //     align: "center"
  //   },
  //   { title: "创建人ID", dataIndex: "inputop", key: "inputop", align: "center" },
  { title: "城市代码", dataIndex: "city", key: "city", align: "center" },
  {
    title: "驾校地址",
    dataIndex: "drivschadress",
    key: "drivschadress",
    align: "center"
  },
  { title: "省代码", dataIndex: "provice", key: "provice", align: "center" },
  { title: "区县代码", dataIndex: "county", key: "county", align: "center" },
  {
    title: "联系人名称",
    dataIndex: "contactsname",
    key: "contactsname",
    align: "center"
  },
  {
    title: "联系人邮箱",
    dataIndex: "contactsemail",
    key: "contactsemail",
    align: "center"
  },
  {
    title: "联系人手机",
    dataIndex: "contactsmobile",
    key: "contactsmobile",
    align: "center"
  },
  {
    title: "联系人电话",
    dataIndex: "contactsphone",
    key: "contactsphone",
    align: "center"
  },
  {
    title: "财务名称",
    dataIndex: "fincontactsname",
    key: "fincontactsname",
    align: "center"
  },
  {
    title: "财务手机",
    dataIndex: "finacontactsmobile",
    key: "finacontactsmobile",
    align: "center"
  },
  {
    title: "财务邮箱",
    dataIndex: "fincontactsemail",
    key: "fincontactsemail",
    align: "center"
  },
  {
    title: "财务电话",
    dataIndex: "fincontactsphone",
    key: "fincontactsphone",
    align: "center"
  },
  //   {
  //     title: "修改时间",
  //     dataIndex: "moddatetime",
  //     key: "moddatetime",
  //     align: "center"
  //   },
  //   { title: "修改人", dataIndex: "modopr", key: "modopr", align: "center" },
  {
    title: "操作",
    key: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center",
    fixed: "right"
  }
];
export default {
  name: "DAssociation",
  props: ["parameters"],
  components: {
    JTable,
    DSchool
  },
  data() {
    return {
      drivasstdetails: [],
      columns,
      loading: false,
      pagination: {
        pageSize: 10,
        pageSizeOptions: ["1", "10", "20", "50", "100"],
        current: 1,
        total: 0
      },
      orderby: "drivschid asc",
      divShow: true,
      detailShow: false,
      params: {},
      spinning:{
        details:true,
        accum:true,
        pass:false,
      },
      accumData:{},
    };
  },
  created() {
    this.getAsstDetails();
    this.getAccumData();
    this.getSchoolList();
  },
  methods: {
    getAsstDetails() {
      //获取驾协详情
      const that = this;
      that.spinning.details = true;
      that.drivasstdetails = [];
      const reqData = {
        drivasstid: this.parameters.drivasstid
      };
      this.$http.post(
        this.$marco.api.asstDetails,
        reqData,
        data => {
          that.spinning.details = false;
          this.$log.success("驾协详情-----" + JSON.stringify(data));
          that.drivasstdetails = data;
        },
        errorDesc => {
          that.spinning.details = false;
          this.$log.normal("驾协详情-----" + JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.details = false;
          this.$log.error("驾协详情-----" + JSON.stringify(error));
        }
      );
    },
    getAccumData(){                         //获取累计数据，包含交易总额、培训合同数、通过率、监管总金额
        const that = this;
        that.accumData = {};
        that.spinning.accum = true;
        const reqData = {
            drivasstid: this.parameters.drivasstid,
            drivschid:'',
        }
        this.$http.post(
            this.$marco.api.accumData,
            reqData,
            data => {
                // this.$log.success('累计数据---------'+JSON.stringify(data));
                that.spinning.accum = false;
                that.accumData = data;

            },
            errorDesc => {
                that.spinning.accum = false;
                this.$log.normal('累计数据---------'+JSON.stringify(errorDesc))
                
            },
            error => {
                that.spinning.accum = false;
                this.$log.error('累计数据---------'+JSON.stringify(error))
                
            }
        );
    },
    getSchoolList() {
      const that = this;
      that.schoolList = [];
      that.loading = true;
      const reqData = {
        currpage: that.pagination.current + "",
        drivasstid: this.parameters.drivasstid,
        // drivschname: "",
        orderby: that.orderby,
        recnumperpage: that.pagination.pageSize + ""
      };

      this.$http.post(
        this.$marco.api.drivschPagingList,
        reqData,
        data => {
          that.loading = false;
          this.$log.success(
            "请求成功返回正确数据------" + JSON.stringify(data)
          );
          that.schoolList = that.schoolList.concat(data.pagelist);
          that.pagination["total"] = data.recnum;
        },
        errorDesc => {
          that.loading = false;
          this.$log.normal(
            "请求成功返回失败--------" + JSON.stringify(errorDesc)
          );
        },
        error => {
          that.loading = false;
          this.$log.error("请求失败---------" + JSON.stringify(error));
        }
      );
    },
    showDetails(record) {
      this.divShow = false;
      this.detailShow = true;
      this.params = {
        drivschid: record.drivschid,
        drivasstid: record.drivasstid
      };
    },
    close() {
      this.$emit("onClose");
    }
  }
};
</script>
<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
.drivasst-name {
  font-size: 20px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.847058823529412);
}
.drivasst-details-keyvalue {
  margin-bottom: 10px;
}
.drivasst-details-key {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.847);
}
.drivasst-details-value {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.647058823529412);
}
.accum-data {
  margin-top: 30px;
}
.span-title {
  font-family: "PingFang-SC-Bold", "PingFang SC Bold", "PingFang SC";
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847058823529412);
  text-align: left;
  line-height: 24px;
}
.accum-title {
  margin-top: 15px;
  font-size: 14px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.427450980392157);
}
.accum-number {
  font-size: 26px;
  line-height: 30px;
  color: rgba(0, 0, 0, 0.847058823529412);
}
.train-project {
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.647058823529412);
}
.train-pass-title {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.427450980392157);
  padding-top: 15px;
}
.train-pass-percent {
  font-size: 28px;
  color: rgba(0, 0, 0, 0.647058823529412);
}
</style>